import React, { ReactElement } from 'react';
import { Redirect, Route, Switch } from 'react-router';
import ValidationPage from './containers/Body/ValidationPage';
import { Footer } from './containers/Footer';
import { LoadingModal } from './components/modals/LoadingModal';
import AssetSelectionPage from './containers/Body/AssetSelectionPage';
import Header from './containers/Header';
// oh u fancy huh
const App = (): ReactElement => {
    return (
        <>
            <LoadingModal />
            <Header />
            <div data-testid="switch-section" className="switch-section">
                <Switch>
                    <Route exact component={ValidationPage} path="/" />
                    <Route exact component={AssetSelectionPage} path="/asset" />
                    <Redirect to="/" />
                </Switch>
            </div>
            <Footer />
        </>
    );
};

export default App;
